import { useState } from 'react';
import { faqs } from '@/mocks/movies';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  return (
    <section id="guide" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10">
          <div className="lg:col-span-4">
            <span className="text-xs md:text-sm font-medium text-primary-600 tracking-widest">GUIDE</span>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
              观影指南与常见问题
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              关于本站内容、评分口径与选片方法，这里一次说明白。点击任意问题即可展开查看完整回答。
            </p>

            <div className="mt-6 rounded-lg border border-background-200/80 bg-background-50 p-5">
              <div className="flex items-center gap-2 text-primary-700">
                <i className="ri-lightbulb-flash-line text-lg" aria-hidden="true"></i>
                <span className="font-medium text-sm">选片小建议</span>
              </div>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                先定类型、再看榜单、最后读口碑。三步之后如果还犹豫，就挑一部评分最高、你还没看过的——大概率不会踩雷。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {faqs.map((item, idx) => {
                const open = openId === item.id;
                return (
                  <div
                    key={item.id}
                    className="rounded-lg border border-background-200/80 bg-background-50 overflow-hidden"
                  >
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenId(open ? null : item.id)}
                        aria-expanded={open}
                        className="w-full flex items-center gap-4 text-left px-4 md:px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors"
                      >
                        <span className="shrink-0 font-heading font-bold text-primary-600 text-base md:text-lg">
                          {String(idx + 1).padStart(2, '0')}
                        </span>
                        <span className="flex-1 font-medium text-sm md:text-base text-foreground-950">
                          {item.q}
                        </span>
                        <i
                          className={`shrink-0 text-xl text-foreground-400 transition-transform duration-300 ${
                            open ? 'ri-subtract-line' : 'ri-add-line'
                          }`}
                          aria-hidden="true"
                        ></i>
                      </button>
                    </h3>
                    <div
                      className={`grid transition-all duration-300 ease-out ${
                        open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="px-4 md:px-5 pb-5 pl-12 md:pl-14 text-sm text-foreground-600 leading-relaxed">
                          {item.a}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}